<template>
    <el-dialog :title="$t('Invite fachstellen')" :visible.sync="inviteFormVisible" :before-close="handleClose">
        <el-form label-position="top" :model="formData" ref="formData" :rules="rules">
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-form-item :label="$t('Fachstellen type')" prop="fachstellen_type">
                    <el-select v-model="formData.fachstellen_type" :placeholder="$t('Fachstellen type')" filterable>
                        <el-option v-for="(item) in fachstellenType" :label="item.label" :key="item.value" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <input type="hidden" v-model="formData.organization_slug" v-if="$store.state.config.user.organization_slug || organization_slug">
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" v-else>
                <el-form-item :label="$t('Select Organization')" prop="organization_slug" :rules="[{ required: true, message: $t('Please select')}]">
                    <el-select v-model="formData.organization_slug" :placeholder="$t('Start typing')" filterable>
                        <el-option v-for="(item) in organizationList.data" :label="item.display_name" :key="item.slug"
                            :value="item.slug"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-form-item :label="$t('Name')" prop="display_name">
                    <el-input v-model="formData.display_name"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-form-item :label="$t('Email')" prop="email">
                    <el-input v-model="formData.email"></el-input>
                </el-form-item>
            </el-col>
            <el-col :lg="24">
                <el-form-item>
                    <el-button type="primary" @click="submitForm('formData')">{{ $t('Send link') }}</el-button>
                    <el-button type="cancel" @click="$emit('closeInviteForm',false)">{{ $t('Cancel') }}</el-button>
                </el-form-item>
            </el-col>
            <img :src="'/static/kipaki-icon.svg'" alt="hand-icon" class="icon-bg" />
        </el-form>
    </el-dialog>
</template>

<script>
    export default {
        props: {
            inviteFormVisible: Boolean,
            fachstellenType: Object,
            organization_slug: String,
            organizationList: Object
        },
        data() {
            return {
                formData: {
                    organization_slug: this.$store.state.config.user.organization_slug || this.organization_slug
                },
                formLabelWidth: '120px',
                rules: {
                    display_name: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "blur"
                    }],
                    email: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "blur"
                    }],
                    fachstellen_type: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "blur"
                    }],
                }
            };
        },
        methods: {
            handleClose() {
                this.$emit('closeInviteForm', false)
            },
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        request({
                                url: "send-invitation",
                                method: "post",
                                data: this.formData
                            })
                            .then(response => {
                                this.$emit('closeInviteForm', false);
                                this.$emit('refreshFachstellen');
                                this.$notify({
                                    title: this.$t('Success'),
                                    message: response.data.message,
                                    type: "success",
                                    offset: 50
                                });
                                this.$refs[formName].resetFields();
                            })
                            .catch(error => {
                                this.$notify({
                                    title: this.$t('Error'),
                                    message: error.response.data.message,
                                    type: "error",
                                    offset: 50
                                });
                            });
                    }
                });
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/Layout/Fachstellen/InviteForm.vue